import { AI_FEATURES_ENABLED } from "../config/featureFlags";

export const aiRankingContent = {
  title: AI_FEATURES_ENABLED ? "AI Scoring & Match Ranking Explanation" : "Opportunity Scoring & Match Ranking Explanation",
  lastUpdated: "June 2026",
  intro: AI_FEATURES_ENABLED
    ? "BizNearYou leverages advanced server-side language models (Gemini AI) and spatial clustering to help map local opportunities and summarize roles."
    : "BizNearYou leverages spatial clustering and activity signal analysis to help map local opportunities and summarize roles.",
  sections: [
    {
      heading: "1. Scoring Mechanics",
      text: "Opportunity scoring and match rankings are calculated based on geographic proximity, company sector relevance, match with user job category preferences, desired compensation brackets, and crawling diagnostics."
    },
    {
      heading: AI_FEATURES_ENABLED ? "2. AI Can Be Incorrect" : "2. Algorithmic Signals Can Be Incomplete",
      text: AI_FEATURES_ENABLED
        ? "Generated business summaries, outreach drafts, and scores are recommendations only. LLMs may produce errors or hallucinations. Always manually check website contents before performing commercial outreach."
        : "Generated business summaries, outreach drafts, and scores are recommendations only. Always manually check website contents before performing commercial outreach."
    },
    {
      heading: "3. No Automated Rejections",
      text: "BizNearYou is strictly prohibited from being utilized as a sole basis for employer candidate filtration or automated applicant rejection. Algorithmic scores aid exploration and networking, but human-led reviews must dictate hiring."
    }
  ]
};
